import {Button} from 'components/system/Button'
import {Frame} from 'components/system/Frame'
import {useOrderActivityDetails} from 'hooks/useOrderActivityDetails'
import {useOrderQuestions} from 'hooks/useOrderQuestions'
import {useWaiting} from 'hooks/useWaiting'
import {useActivityPath, useConfirmingPath} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {VentrataPaymentProvider} from 'providers/VentrataPaymentProvider'
import {useCallback, useEffect, useState} from 'react'
import {Navigate} from 'react-router'
import {singleCall} from 'utils/singleCall'
import {areRequiredFieldsFilled} from '../Activity/utils/areRequiredFieldsFilled'
import {SecurePaymentMessage} from './SecurePaymentMessage'
import {View} from './View'

export const Payment = () => {
  const order = OrderProvider.useOrder()
  const [ready, setReady] = useState(false)
  const {finish, start} = useWaiting()
  const confirmingPath = useConfirmingPath()
  const activityPath = useActivityPath()
  const orderQuestions = useOrderQuestions()
  const orderActivityDetails = useOrderActivityDetails()
  const requiredFieldsAreFilled = areRequiredFieldsFilled(orderQuestions, orderActivityDetails)

  useEffect(() => {
    if (!requiredFieldsAreFilled) {
      return
    }

    singleCall('waitingPaymentForm', () => start())
  }, [start, order, requiredFieldsAreFilled])

  const onReady = useCallback(() => {
    setReady(true)
    finish()
  }, [finish])

  const returnToActivityPage = useCallback(() => {
    window.location.href = activityPath
  }, [activityPath])

  if (order.status === 'CONFIRMED') {
    return <Navigate to={confirmingPath} />
  }

  if (!requiredFieldsAreFilled) {
    return (
      <div className="flex flex-col gap-6">
        <h3 className="font-bold text-2xl">Complete payment details</h3>
        <SecurePaymentMessage />
        <Frame className="flex justify-between items-center p-4">
          <div className="basis-1/2">Complete activity details</div>
          <Button.Primary.Orange onClick={returnToActivityPage} className="!px-3 basis-1/2">
            Return to activity details
          </Button.Primary.Orange>
        </Frame>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-6">
      {ready ? (
        <h3 className="font-bold text-2xl">Complete payment details</h3>
      ) : (
        <h3 className="font-bold text-2xl">Loading payment form...</h3>
      )}
      <SecurePaymentMessage />
      {
        <VentrataPaymentProvider>
          <View ready={ready} onReady={onReady} />
        </VentrataPaymentProvider>
      }
    </div>
  )
}
